import React, { useEffect, useState,} from 'react'
import '../styles/program.scss'
import _ from 'lodash'
import moment from 'moment'
import ShowtimeProgram from './ShowtimeProgram';




import { useLocation } from "react-router-dom";
import LOCALE from '../../datepicker/DatePickerLocale'





export default function ShowtimeListItems({ cinema, take, currentStartDate, nextWeek, previousWeek, lastShowtimeDa, firstWeek, lastWeek, nextValidWeek, site_type, iframeId }) {
 
   
   
    const allShowtimeTypes = []
    
   
    const [dimNextArrow, setDimNextArrow] = useState(false)
    const [dimBackArrow, setDimBackArrow] = useState(currentStartDate === moment() ? true : false)
   
   

    const showtimesByDate = _.groupBy(cinema.validShowtimes, (showtime) => {
      
        if (showtime._eventTypeNo !== 0) {
            allShowtimeTypes.push(showtime.type == null ? null : showtime.type[0])
        }
        return /*base === 'true' ? showtime.movieId === movie.id && moment(showtime.dateTime).format('YYYY-MM-DD') :*/ moment(showtime.dateTime).format('YYYY-MM-DD'); // needs if condition on queryparams
    });

  
    function toFindDuplicates(showtimeTypes) {
        const uniqueElements = new Set(showtimeTypes);

        showtimeTypes.filter((item) => {
            if (uniqueElements.has(item)) {

            } else {
                return item;
            }
        });

        return [...new Set(uniqueElements)];
    }
    const showtimeTypes = toFindDuplicates(allShowtimeTypes)
  

    let shoss = [{}]
    const generateShowtimesOnDate = (showtimesOnDate, MAX,) => {
        let s = showtimesOnDate && showtimesOnDate.length
       

        return showtimesOnDate ? _.map(showtimesOnDate, (showtime, index) => {

            shoss.push(showtime)
         //   console.log(showtime, 'showtime', index)
            return <ShowtimeProgram showtime={showtime} index={index} site_type={site_type}
                date_text={showtime.dateTime.split('T')[1].slice(0, 5)} showtimeTypes={showtimeTypes} iframeId={iframeId} />;

            return shoss



        })
            :
            Array.from({ length: MAX })
                .map((_, index) => (
                    <div className="Showtime hidden_Showtime" key={index} style={{ marginTop: '3px' }}></div>
                )
                )
        // return <div className="Showtime" style={{ backgroundColor: '#327365', marginTop: '3px' }}>fff</div>          
    }

    let startDate = currentStartDate;
    if (!startDate && cinema.validShowtimes.length > 0) startDate = moment(cinema.validShowtimes[0].dateTime);


    const generateWeekSchedule = (startDateOrg ) => {
          startDate = startDateOrg.clone(); // we don't want to mutate it

        const weekScheduleItems = [];
    

        let showtimesOnDateMAX = 0
        for (var i = 0; i < take; i++) {
            const x = showtimesByDate[startDate.format('YYYY-MM-DD')] /*_.map(showtimesByDate, (shows) => { return shows[startDate.format('YYYY-MM-DD')] })*/
           // console.log(x, 'x')
            if (x != null && x.length > showtimesOnDateMAX) showtimesOnDateMAX = x.length
             startDate.add(1, 'day')
        }

          startDate = startDateOrg.clone(); // we don't want to mutate it
       // console.log(startDate.format('YYYY-MM-DD'), 'start date')
       // console.log(showtimesOnDateMAX, 'MAX showtimes')

        for (var i = 0; i < take; i++) {
            const date = moment(startDate);
            // console.log(date, 'date')
            const formattedDate = _.capitalize(date.locale("da").format('dddd D/M'))
            const today = date.isSame(moment(), 'day') ? 'I dag' : ''
            const tomorrow = date.isSame(moment().add(1, 'day'), 'day') ? 'I morgen' : ''
            const showtimesOnDate = showtimesByDate[startDate.format('YYYY-MM-DD')] /*_.map(showtimesByDate, (shows) => { return shows[startDate.format('YYYY-MM-DD')] })*/
         
          //  console.log(showtimesOnDate, 'showtimes on date')

            weekScheduleItems.push(

                <div key={startDate} className="showtimes-on-date">

                    <h4 className="date">{today || tomorrow || formattedDate}</h4>
                    <div>{generateShowtimesOnDate(showtimesOnDate, showtimesOnDateMAX,)}  </div>

                    {/*<div> {generateNoShowtimeDiv(showtimesOnDateMAX, showtimesOnDate)} </div>*/}

                </div>

            )

            startDate.add(1, 'day');
        }

        return weekScheduleItems

    }
  

    let firstShowtime = moment(cinema.validShowtimes[0].dateTime).format('YYYY-MM-DD')

    let str = currentStartDate.format('YYYY-MM-DD')
    let ff = cinema.validShowtimes
    let fg = ff[ff.length - 1]

    var widths = [0, 431, 850];
    let lastShowtime = moment(fg.dateTime).format('YYYY-MM-DD')

    const currentEndDate = currentStartDate.clone().add((take - 1), 'days');

    /*-------------FINDING OUT if there are showtimes in currentWeek------*/
    let tw = 0
    useEffect(() => {

        _.map(cinema.validShowtimes, showtime => {

            if ((moment(showtime.dateTime).isBetween(currentStartDate, currentEndDate)) && tw == 0) {
                tw = 1
            }

        })

    })
   

    /*-------------FINDING OUT WHEN TO DISABLE NEXT ARROW------*/
    let nextWeekStrD = currentStartDate.clone().add(take, 'days');
    let nextWeekEndD = currentEndDate.clone().add(take, 'days')


    let nw = 0
    useEffect(() => {
        _.map(cinema.validShowtimes, showtime => {

            if ((moment(showtime.dateTime).isBetween(nextWeekStrD, nextWeekEndD) || (moment(showtime.dateTime).isAfter(nextWeekEndD) && tw == 1)) && nw == 0) {
                nw = 1
            }
            //}
        })
        if (nw == 0) setDimNextArrow(true)
        else setDimNextArrow(false)

    })

    /*----------FINDING OUT WHEN TO DISABLE BACK ARROW----------*/
    let lastWeekStrD = currentStartDate.clone().subtract(take, 'days')
    let lastWeekEndD = currentEndDate.clone().subtract(take, 'days')


    let lw = 0
    useEffect(() => {
        let td = currentStartDate
        let tm = moment().add(1, 'days')
        let isCrntDisT = td.isSame(tm, 'day')

        _.map(cinema.validShowtimes, showtime => {

            if ((moment(showtime.dateTime).isBetween(lastWeekStrD, lastWeekEndD) ||
                (moment(showtime.dateTime).isBefore(currentStartDate) && isCrntDisT) || (moment(showtime.dateTime).isSame(lastWeekEndD, 'day'))
                || (moment(showtime.dateTime).isBefore(lastWeekStrD) && tw == 1)) && lw == 0) {
                lw = 1
            }

        })
      //  console.log(lw, 'lw')
        if (lw == 0) setDimBackArrow(true)
        else setDimBackArrow(false)

    })

    let datejump = []
    _.map(cinema.validShowtimes, showtime => {

        let check = moment(showtime.dateTime).format('YYYY-MM-DD') >= currentStartDate.clone().add((take), 'days').format('YYYY-MM-DD')
        if (check === true) {
            datejump.push(showtime.dateTime)

            return showtime.dateTime
        }

    })


    let dateBack = []


    _.map(cinema.validShowtimes, showtime => {

        let check = moment(showtime.dateTime).format('YYYY-MM-DD') < currentStartDate.clone().format('YYYY-MM-DD')
        if (check === true) {

            dateBack.push(showtime.dateTime.slice(0, 10))

            return showtime.dateTime
        }

    });
    var date1 = moment(str);
    var date2 = moment(datejump[0]);
    var date3 = moment(lastShowtime)
    var date4 = moment(dateBack[dateBack.length - 1])

    var differ = date2.diff(date1, 'days')
    var forrigeDiffer = date4.diff(date1, 'days')


    var diff = date1.diff(date3, 'days')

    useEffect(() => {
    //    //generateWeekSchedule(currentStartDate)
    //    console.log('use eff')
    //    console.log(startDate, 'start date')
    }, [currentStartDate])

  
    return (
        <>
            <div className='bio_name_container'>
                <p className='bio_name'>{cinema.bio_name}</p>
            </div>
            <section className='schedule'>
                
                <div className='showtimeScheduleWeek' >
               
                  {generateWeekSchedule(currentStartDate)}
               
                </div>
                <div style={{ textAlign: 'center' }}>

                    <div className='inBetweenShowtimes' style={{ left: lastShowtime < str && firstShowtime < str || firstShowtime > str ? '40%':'30%'} }>
                       
                    {shoss.length <= 1 ?
                        lastShowtime < str ?
                          <div>
                                <div  className="previousShowBtn show-navigations" onClick={() => lastWeek(diff)}>
                                    <span
                                        //style={{ marginLeft: window.innerWidth < widths[1] ? '0px' : '7px', marginTop: /*window.innerWidth < widths[1] ? '15px' : */'20px' }}
                                    >
                                            <svg style={{marginTop:'4px'}} xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                                            <path d="M7.91663 3.11108L2.36107 8.66664L7.91663 14.2222" stroke="white" stroke-width="1.11111" stroke-linecap="round" />
                                        </svg>
                                </span>
                                        <p style={{ letterSpacing: '0.54px', paddingLeft: '10px', height: '25px', fontWeight: 600 }}>Sidste forestillinger</p>
                                    </div>
                              </div>
                                :
                                firstShowtime < str ?
                                    <div className="leftRightShowtimes" >
                                        <div style={{ display: 'flex' }} className="previousShowBtn  show-navigations" onClick={() => nextValidWeek(forrigeDiffer)} >
                                            <span >
                                                <svg style={{ marginTop: '5px' }} xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                                                    <path d="M7.91663 3.11108L2.36107 8.66664L7.91663 14.2222" stroke="white" stroke-width="1.11111" stroke-linecap="round" />
                                                </svg>
                                            </span>
                                            <p style={{ letterSpacing: '0.54px', paddingLeft: '10px', fontWeight: 600 }}>Forrige forestillinger</p>
                                        </div>
                                        <div className="nextShowBtn  show-navigations" onClick={() => firstWeek(differ)}>
                                            <p style={{ letterSpacing: '0.54px', fontWeight: 600 }}>Næste forestillinger</p>
                                            <span className="ty" >
                                                <svg style={{ marginTop: '8px', marginLeft: '10px' }} xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                                                    <path d="M2.36108 3.11108L7.91664 8.66664L2.36108 14.2222" stroke="white" stroke-width="1.11111" stroke-linecap="round" />
                                                </svg>
                                            </span>
                                        </div>

                                    </div>

                                    :
                                    <div>
                                      <div  className="show-navigations" onClick={() => firstWeek(differ)}>
                                        <p style={{ letterSpacing: '0.54px', height: '25px',fontWeight:600 }}>Næste forestillinger</p>
                                        <span
                                            style={{ marginLeft: window.innerWidth < widths[1] ? '0px' : '10px',marginTop:'6px' }}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                                                <path d="M2.36108 3.11108L7.91664 8.66664L2.36108 14.2222" stroke="white" stroke-width="1.11111" stroke-linecap="round" />
                                            </svg>
                                       </span>
                                      </div>
                                </div>

                        : ''}
                    </div>
                <br></br>
                </div> 

                {
                    shoss.length <= 1 || lastShowtime < str ? '' :
                        <div className='moviesArrows'>
                            <div className={dimNextArrow === false ? 'week-nav ' : 'week-nav disabled'} onClick={nextWeek} >
                                <span>
                                    <svg className="moviesRightArr" style={{
                                        position: window.innerWidth < widths[1] ? 'absolute' : '', top: window.innerWidth < widths[1] ? '10px' : '',
                                        right: window.innerWidth < widths[1] ? '0%' : '40%'
                                    }} xmlns="http://www.w3.org/2000/svg" width="18" height="30" viewBox="0 0 18 30" fill="none">
                                        <path d="M4.25 5L14.25 15L4.25 25" stroke="white" stroke-width="2" stroke-linecap="round" />
                                    </svg>


                                </span>
                            </div>
                            <div className={dimBackArrow === false ? 'week-nav ' : 'week-nav disabled'} onClick={previousWeek} style={{ marginTop: '5px' }}>
                                <span>
                                    <svg className="moviesLeftArr" style={{
                                        position: window.innerWidth < widths[1] ? 'absolute' : '', top: window.innerWidth < widths[1] ? '10px' : '', right: window.innerWidth < widths[1] ? '' : '43%',
                                        left: window.innerWidth < widths[1] ? '0%' : ''
                                    }} xmlns="http://www.w3.org/2000/svg" width="18" height="30" viewBox="0 0 18 30" fill="none">
                                        <path d="M14.25 5L4.25 15L14.25 25" stroke="white" stroke-width="2" stroke-linecap="round" />
                                    </svg>

                                </span>
                            </div>
                        </div>
                }
            </section>
            {
                shoss.length <= 1 || lastShowtime < str ? '' :
            <section className="showtimeTypeContainer" style={{ marginTop: window.innerWidth < widths[1] ? '-6px' : '',color:'white' }}>

                <div className='showtimeTypes' style={{ marginTop: window.innerWidth < widths[1]  ? '20px' : ''} }>
                            {showtimeTypes.map((types, index) => (
                                <span style={{ marginRight: '50px',  }}>
                                    <span className='showtime-type-number' >{index + 1}</span>
                                    <span className='showtime-type-name' style={{ letterSpacing: '0.51px', }}>{types?.name}</span>
                    </span>
                )

                )}
                </div>

            </section>
                    }
            <hr style={{ opacity: '0.1', margin: shoss.length <= 1 || lastShowtime < str ? '90px 0px 40px 0px' :  '32px 0px 40px 0px' }} />

        </>
    )
}